import React, { Component } from "react";
import { Card, Grid, Button } from "@material-ui/core";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import Alert from '@material-ui/lab/Alert';
import jwtAuthService from "app/services/jwtAuthService";
import UserService from "app/services/UserService";
import Snackbar from '@material-ui/core/Snackbar';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import { resetPassword } from "../../redux/actions/LoginActions";
import * as appconst from '../../appconst';

class ForgotPassword extends Component {
  state = {
    email: "",
    message: false,
    messageText: "",
    severity: "error",
    open_sent: false,
    data_error: false,
  };

  handleChange = event => {
    event.persist();
    this.setState({
      [event.target.name]: event.target.value
    });
  };
  // handleFormSubmit = async () => {
  //   //this.props.resetPassword({ ...this.state });
  //   let res = await jwtAuthService.reSetPassword(this.state.email);
  //   console.log("response", res)
  //   if (res.data.success) {
  //     this.setState({
  //       message: true,
  //       messageText: res.data.message,
  //       severity: "success"
  //     })
  //   } else {
  //     if (!res.data.success) {
  //       this.setState({
  //         message: true,
  //         messageText: res.data.message,
  //         severity: "error"
  //       })
  //     } else {
  //       this.setState({
  //         message: true,
  //         messageText: "There is problem contact system administrator",
  //         severity: "error"
  //       })
  //     }
  //   }


  // };

  handleFormSubmit = async () => {
    this.setState({ disable_submit_button: true });

    var email = this.state.email;
    var name;
    var link;

    UserService.getAllUsersByEmail(email).then((res) => {
      if (res.data.length >= 1) {

        name = res.data[0].name;
        link = "session/reset-password?pw_rs=kj356df74as890d" + res.data[0].user.id + "k2sd8df253d9dd"

        var bodyFormData = new FormData();

        bodyFormData.append('name', name);
        bodyFormData.append('email', email);
        bodyFormData.append('link', link);

        UserService.sendPasswordResetLink(bodyFormData).then((res) => {
          if (res.data.EmailFormat.length >= 1) {
            this.setState({ message: res.data.message, snakebar: true, severity: "success", disable_submit_button: false, email: "" })
            this.handleOpenSent();
          } else {
            this.setState({ disable_submit_button: false });
          }
        })
      } else {
        this.setState({ disable_submit_button: false, data_error: true });
      }
    })

  };

  handleOpenSent = () => {//For handle edit dialog
    this.setState({ open_sent: true })
  }

  handleCloseSent = () => {//For handle edit dialog
    this.setState({ open_sent: false })
  }
  render() {
    let { email } = this.state;

    return (
      <div className="signup flex justify-center w-full h-full-screen"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          backgroundImage: 'url("/assets/images/sign_up_bg.jpg")',
          width: "100%",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <div className="p-8">
          <Card className="signup-card position-relative y-center">
            <Grid container>
              {/* <Grid item lg={5} md={5} sm={5} xs={12}>
                <div className="p-8 flex justify-center items-center h-full">
                  <img src="/assets/images/illustrations/dreamer.svg" alt="" />
                </div>
              </Grid> */}
              <Grid item >
                <div className="p-9 h-full bg-white position-relative">
                  <ValidatorForm ref="form" onSubmit={this.handleFormSubmit}>
                    <TextValidator
                      className="mb-6 w-324"
                      variant="outlined"
                      label="Email"
                      onChange={this.handleChange}
                      type="email"
                      name="email"
                      size="small"
                      value={email}
                      validators={["required", "isEmail"]}
                      errorMessages={[
                        "this field is required",
                        "email is not valid"
                      ]}
                    />

                    {this.state.data_error ?
                      <p style={{ color: "red", fontSize: 11.5 }} className="mt--5 ml-5">incorrect user</p>
                      : ""
                    }
                    <div className="flex items-center">
                      <Grid container spacing={2} align="center">
                        <Grid item md={12} sm={12} xs={12}>
                          <Button variant="contained" color="primary" type="submit" disabled={this.state.disable_submit_button}>
                            Reset Password
                          </Button>
                        </Grid>
                        <Grid item md={12} sm={12} xs={12}>
                          <Button
                            className="text-primary"
                            onClick={() =>
                              this.props.history.push("/session/signin")
                            }
                          >
                            Login to your Account
                          </Button>
                        </Grid>
                      </Grid>
                    </div>
                  </ValidatorForm>
                  <Dialog fullWidth={true} maxWidth="xs" onClose={() => { this.handleCloseSent(); }} aria-labelledby="customized-dialog-title" open={this.state.open_sent}>
                    <Typography style={{ color: "darkgreen" }} className="pl-5 pt-5 pr-5 pb-5">
                      Please check your email for the password reset link
                    </Typography>
                  </Dialog>
                </div>
              </Grid>
            </Grid>
          </Card>
          <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={this.state.snakebar} autoHideDuration={2500} onClose={this.handleClose}>
            <Alert onClose={this.handleClose} severity={this.state.severity}>
              {this.state.message}
            </Alert>
          </Snackbar>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  resetPassword: PropTypes.func.isRequired,
  login: state.login
});
export default withRouter(
  connect(mapStateToProps, { resetPassword })(ForgotPassword)
);
